import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DropDownSelectorValues,
  ProjectStatus as ProjectStatusEnum,
  SubPage,
  Tab,
} from '@symfa-inc/providence-verizon-types';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { LeasingHttpService } from '@core/services/http';
import { useLeasingTabPrefetch } from '@core/utils/hooks';
import {
  canUserEditByProjectStatusAndRoles,
  getProjectBundleIDParamFromUrl,
} from '@core/utils/methods';
import { TabComponentProps } from '@models/interfaces';
import { EditablePage } from '@shared/components';
import { LeasingActions } from '@store/actions';
import {
  DDVSelectors,
  LeasingSelectors,
  ProjectSelectors,
  UserSelectors,
} from '@store/selectors';
import { Workflow } from './components';

export const LeasingWorkflow: FC<TabComponentProps> = ({ isActive }) => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(
    LeasingSelectors.getTabLoadingState('workflow'),
  );
  const isDataLoaded = useSelector(
    LeasingSelectors.getTabLoadedState('workflow'),
  );

  const { browse } = useSelector(UserSelectors.getLeasingPermissions);
  const projectType = useSelector(LeasingSelectors.getProjectType);
  const projectTypePermission = useSelector(
    UserSelectors.canEditProjectByProjectType(projectType),
  );
  const canEdit = useSelector(
    UserSelectors.canEdit('leasing', SubPage.LeasingBrowse, Tab.Workflow),
  );
  const userRoles = useSelector(UserSelectors.getUserRoles);
  const projectStatusId = useSelector(ProjectSelectors.getProjectStatus);
  const projectStatus = useSelector(
    DDVSelectors.getCurrentDDVValueById<ProjectStatusEnum>(
      DropDownSelectorValues.ProjectStatus,
      projectStatusId,
    ),
  );

  useLeasingTabPrefetch('workflow', projectBundleID);

  useEffect(() => {
    if (!isDataLoaded) {
      dispatch(
        LeasingActions.setTabLoading.done({
          tabName: 'workflow',
          isLoading: true,
        }),
      );
      HttpService.getHttpRequests(LeasingHttpService).getLeasingWorkflowData(
        projectBundleID,
      );
    }
  }, [isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-leasing-workflow loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <EditablePage
      isActive={isActive}
      editableComponent={Workflow}
      permissions={browse}
      canUserEdit={
        canEdit &&
        projectTypePermission &&
        canUserEditByProjectStatusAndRoles(projectStatus, userRoles)
      }
    />
  );
};
